<template>
  <div class="clearfix">
    <a-upload
      :action="uploadImgUrl"
      :list-type="type == 'image' ? 'picture-card' : 'picture'"
      :show-upload-list="false"
      :headers="headers"
      :preview-file="previewFile"
      :before-upload="beforeUpload"
      @change="handleChange"
    >
      <div v-if="imgUrl" style="position: relative">
         <div class="preview_pic" v-if="suffix(imgUrl)!='pdf'" @click.stop="previewImg(ossUrl + imgUrl)">预览图片</div>
         <div class="preview_pdf" v-else @click.stop="previewPdf(ossUrl + imgUrl)">查看PDF</div>
        <img
          v-if="
            imgUrl &&
            (((imgUrl.indexOf('jpg') > -1 ||
              imgUrl.indexOf('jpeg') > -1 ||
              imgUrl.indexOf('png') > -1 || 
              imgUrl.indexOf('gif') > -1) &&
              type.indexOf('image') > -1) ||
              fileType == 'image')
          "
          :src="ossUrl + imgUrl"
          alt="avatar"
        />
       
        <video
          v-else-if="
            imgUrl &&
            (imgUrl.indexOf('avi') > -1 ||
              imgUrl.indexOf('mpeg') > -1 ||
              imgUrl.indexOf('mp4') > -1 ||
              imgUrl.indexOf('mov') > -1 ||
              imgUrl.indexOf('wmv') > -1 ||
              imgUrl.indexOf('flv') > -1 ||
              imgUrl.indexOf('rmvb') > -1 ||
              imgUrl.indexOf('mp3') > -1)
          "
          :src="ossUrl + imgUrl"
          controls="controls"
        >
          您的浏览器不支持 video 标签。
        </video>
        <div v-else-if="suffix(imgUrl)=='pdf'" style="width:128px;height:128px;padding-top:35px">
            <p class="pdf">
              {{fileName}}
            </p>
        </div>
        <video v-else :src="ossUrl + imgUrl" controls="controls">></video>
        <!-- <a-button class="btn_delete_file" type="link" @click.stop="deleteFile(ossId)">
          <a-icon type="close-circle" />
        </a-button> -->
      </div>
      <div v-if="type == 'file'">
        <a-button>
          <a-icon type="upload" />
          <!-- 上传 -->
        </a-button>
      </div>
      <div v-if="imgUrl == '' || imgUrl == null">
        <span class="addImgCls" v-if="type.indexOf('image') > -1">
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">
            <!-- 上传 -->
          </div>
        </span>
      </div>
    </a-upload>
    <span v-if="imgUrl && type == 'file'">
      <br />
      <a :href="ossUrl + imgUrl" target="_blank">{{ ossUrl + imgUrl }}</a>
    </span>
    <div v-if="showPreview" class="preview_cover"  @click="closeCover">
      <img class="preview_img" title="点击任意位置退出预览" :src="previewImgUrl" alt="preview"/>
    </div>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'UploadCmp',
  props: {
    imgUrl: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'image',
    },
    fileName:{
       type: String,
      default: '',
    },
    ossId: {
      type: Number,
      default: -1,
    },
    fileTypesss:{
      type: String,
      default: 'image',
    },
    count: {
      type: Number,
      default: 1,
    },
    filename: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {
      loading: false,
      isHidePdf:false,
      open: false,
      ossUrl: process.env.VUE_APP_OSS_URL,
      uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*',
        // MacAddressAuth: 'MacAddressAuth'
      },
      fileType: '',
      showPreview:false,//是否显示预览图
      previewImgUrl:'',//预览图片url
    }
  },
  mounted() {},
  created() {},
  methods: {
    previewPdf(url){
      window.location=url
    },
    previewImg(url){
      this.showPreview=true
      this.previewImgUrl=url
    },
    closeCover(){
       this.showPreview=false
      this.previewImgUrl=""
    },
    previewFile(file) {
      console.log('Your upload file:', file)
      return fetch('https://next.json-generator.com/api/json/get/4ytyBoLK8', {
        method: 'POST',
        body: file,
      })
        .then((res) => res.json())
        .then(({ thumbnail }) => thumbnail)
    },

    handleCancel() {
      this.previewVisible = false
    },
    suffix(value){
      let data= value.split('.')
      return data[data.length-1]
    },
    async handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.code !== 200) {
          this.$message.error('上传失败' + info.file.response.msg)
          this.loading = false
          return
        }
        this.loading = false
        this.$emit('deleteFile', this.ossId)
        this.$emit('fileUrlFn', info.file.response.data)
      }
    },
    beforeUpload(file) {
      console.log(file.type,'file.type')
      let isJpgOrPng = true
      if(this.fileTypesss=='pdf'){
        isJpgOrPng= file.type === 'image/jpeg' || file.type === 'image/png' || file.type==='application/pdf'
      }else{
        isJpgOrPng= file.type === 'image/jpeg' || file.type === 'image/png'
      }
      if (!isJpgOrPng) {
        this.$message.error('只能上传jpg/png或jpeg!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小限制 2MB!')
      }
      return isJpgOrPng && isLt2M
    },
  },
}
</script>
<style lang="less" scoped>
.preview_pic{
  position:absolute;
  left:0%;
  top:0%;
  z-index:9;
  background:rgba(0,0,0,0.6);
  width:100%;
  height:30px;
  line-height:30px;
  font-size:14px;
  color:#fff;
}
.preview_pdf{
  background:rgba(0,0,0,0.6);
  width:100%;
  height:30px;
  position:absolute;
  left:0%;
  top:0;
  line-height:30px;
  font-size:14px;
  color:#fff;
}
.preview_cover{
  width:100vw;
  height:100vh;
  background:rgba(0,0,0,0.6);
  position:fixed;
  z-index:99;
  left:0;
  top:0;
  cursor:pointer;
}
.preview_img{
  width:90%;
  height:90%;
  object-fit: contain;
  margin: 5%;
  cursor:pointer;
  border-radius:10px;
  -wekit-border-radius:10px;
}
.addImgCls {
  border: 1px solid #f2f2f2;
  display: flex;
  width: 128px;
  height: 128px;
  text-align: center;
  align-items: center;
  justify-content: center;
}

img {
  width: 128px;
  height: 128px;
  object-fit: cover;
}
video {
  width: 400px;
  height: 200px;
}
.btn_delete_file {
  position: absolute;
  right: -23px;
  top: -15px;
  z-index: 99;
}
</style>
